/**
 * The one place a command bus's seq counter lives — everything downstream sends through
 * here instead of touching seq itself.
 */

interface Envelope<P = unknown> {
  event: string;
  payload: P;
}

export class Dispatcher {
  private seq = 0;

  constructor(private send: (text: string) => boolean) {}

  private envelope<P>(event: string, payload: P): string {
    return JSON.stringify({ event, payload } satisfies Envelope<P>);
  }

  dispatch(msg: { event: string; payload: object }): boolean {
    return this.send(this.envelope(msg.event, msg.payload));
  }

  dispatchSeq(msg: { event: string; payload: object }): boolean {
    return this.send(this.envelope(msg.event, { ...msg.payload, seq: ++this.seq }));
  }
}
